import React from "react";
import InputSideBar from "./InputSideBar";
import OutputSideBar from "./OutputSideBar";
import "./App.css"; // For container styles

export default function App() {
  return (
    <div className="container">
      <InputSideBar />
      {/* <OutputSideBar /> */}
    </div>
  );
}
